import {AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import {KfRegistrationDetail} from '../../models/kf-registration-detail.interface';
import {Master} from '../../../admin/models/master.interface';
import {FormArray, FormBuilder, FormControl, Validators} from '@angular/forms';
import {KfRegistrationService} from '../../services/kf-registration.service';
import {Router} from '@angular/router';
import {QuantitativeDetail} from '../../models/quantitative-detail.interface';
import {Additional} from '../../models/additional.interface';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Currency} from '../../models/currency.interface';
import {AuthService} from '../../../core/services/auth.service';

@Component({
  selector: 'app-kf-registration-edit-table-cost-undifferentiated',
  templateUrl: './kf-registration-edit-table-cost-undifferentiated.component.html',
  styleUrls: ['./kf-registration-edit-table-cost-undifferentiated.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      )
    ])
  ]
})

export class KfRegistrationEditTableCostUndifferentiatedComponent implements OnInit, AfterContentChecked {

  simpleUser = true;
  totalValues = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  icon = [{icon: '', expanded: false}];
  additionalDataSource = [
    {entry: 'A. Col. LHA', payment: 0, remark: ''},
    {entry: 'B. Col. TEE', payment: 0, remark: ''},
    {entry: 'C. Col. Small IT', payment: 0, remark: ''},
    {entry: 'D. Col. Small', payment: 0, remark: ''},
    {entry: 'E. Col. Screens', payment: 0, remark: ''},
    {entry: 'F. Col. Lamps', payment: 0, remark: ''},
    {entry: 'G. Col. PV', payment: 0, remark: ''},
    {entry: 'X. Col Other', payment: 0, remark: ''},
  ];
  additionalIcon = [
    {icon: 'keyboard_arrow_right', expanded: false},
    {icon: 'keyboard_arrow_right', expanded: false},
    {icon: 'keyboard_arrow_right', expanded: false}
  ];

  otherDataSource = [
    {entry: 'Define other', remark: ''},
  ];
  expandedElement!: {
    collection: number,
    logistics: number,
    treatment: number,
    clearingHouse: number,
    communication: number,
    rd: number,
    office: number,
    other: number,
    totalOperations: number,
    totalOverhead: number,
    remark: string,
  } | null;

  expandedAdditionalElement!: {
    payment: number,
    remark: string,
  } | null;

  displayedColumnsOperations: string[] = ['entry', 'collection', 'logistics', 'treatment', 'total', 'operationsRemark'];
  displayedColumnsOverhead: string[] = ['entry', 'clearing-house', 'communication', 'rd', 'office', 'other', 'total', 'overheadRemark'];
  additionalDisplayedColumns: string[] = ['entry', 'paymentRetail', 'paymentPoint', 'paymentOther', 'remark'];

  currencyForm = this.formBuilder.group({
    currency: [''],
    equivalence: [0, Validators.required],
    source: ['', Validators.required],
  });

  entriesForm = this.formBuilder.group({
    entries: this.formBuilder.array([this.formBuilder.group({
      collection: [],
      logistics: [],
      treatment: [],
      clearingHouse: [],
      communication: [],
      rd: [],
      office: [],
      other: [],
      total: [0],
      remark: [''],
      operationsRemark: [''],
      overheadRemark: [''],
      collectionDifferentValueAllowed: [false],
      logisticsDifferentValueAllowed: [false],
      treatmentDifferentValueAllowed: [false],
      clearingHouseDifferentValueAllowed: [false],
      communicationDifferentValueAllowed: [false],
      rdDifferentValueAllowed: [false],
      officeDifferentValueAllowed: [false],
      otherDifferentValueAllowed: [false]
    })])
  });

  additionalForm = this.formBuilder.group({
    entries: this.formBuilder.array([
      this.formBuilder.group({paymentRetail: [], paymentPoint: [], paymentOther: [], remarks: [''], }),
      this.formBuilder.group({paymentRetail: [], paymentPoint: [], paymentOther: [], remarks: [''], }),
      this.formBuilder.group({paymentRetail: [], paymentPoint: [], paymentOther: [], remarks: [''], }),
      this.formBuilder.group({paymentRetail: [], paymentPoint: [], paymentOther: [], remarks: [''], }),
      this.formBuilder.group({paymentRetail: [], paymentPoint: [], paymentOther: [], remarks: [''], }),
      this.formBuilder.group({paymentRetail: [], paymentPoint: [], paymentOther: [], remarks: [''], }),
      this.formBuilder.group({paymentRetail: [], paymentPoint: [], paymentOther: [], remarks: [''], }),
      this.formBuilder.group({paymentRetail: [], paymentPoint: [], paymentOther: [], remarks: [''], }),
    ])
  });

  get entriesControl(): FormArray {
    return this.entriesForm.get('entries') as FormArray;
  }

  get currencyControl(): FormControl {
    return this.currencyForm.get('currency') as FormControl;
  }

  get equivalenceControl(): FormControl {
    return this.currencyForm.get('equivalence') as FormControl;
  }

  get sourceControl(): FormControl {
    return this.currencyForm.get('source') as FormControl;
  }

  get additionalControl(): FormArray {
    return this.additionalForm.get('entries') as FormArray;
  }

  @Input()
  kfRegistrationDetail!: KfRegistrationDetail;
  @Input()
  newKfRegistrationDetail!: KfRegistrationDetail;
  @Input()
  categories!: Master[];
  @Input()
  b2bb2c!: string;
  @Input()
  currencies!: Currency[];

  @Output()
  markAsCompletedEmitter: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  resetEmitter: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  redirectUrlEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor(private readonly formBuilder: FormBuilder,
              private readonly kfRegistrationService: KfRegistrationService,
              private readonly router: Router,
              private readonly authService: AuthService,
              private readonly changeDetector: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.simpleUser = this.authService.userHasAnyRole(['SIMPLE_USER']);
    this.icon = [];
    if (this.kfRegistrationDetail?.kfRegistration && this.kfRegistrationDetail?.categories && this.kfRegistrationDetail.categories.length > 0) {
      this.currencyControl.setValue(this.kfRegistrationDetail.kfRegistration.currency);
      this.currencyControl.disable();
      this.equivalenceControl.setValue(this.kfRegistrationDetail.kfRegistration.equivalence);
      this.sourceControl.setValue(this.kfRegistrationDetail.kfRegistration.source);
      this.setEntriesFormArray(this.kfRegistrationDetail.categories.length, this.kfRegistrationDetail);
      this.entriesControl.controls.forEach((control, index) => {
        control.get('collection')?.setValue(
          Number(this.equivalenceControl.value.toFixed(2)) === 0
            ? (this.kfRegistrationDetail.categories[index].collection !== 0
            ? this.kfRegistrationDetail.categories[index].collection
            : (this.kfRegistrationDetail.kfRegistration.completionStatus ? this.kfRegistrationDetail.categories[index].collection : null))
            : Number(this.kfRegistrationDetail.categories[index].collection / this.equivalenceControl.value).toFixed(2)
        );
        control.get('logistics')?.setValue(
          Number(this.equivalenceControl.value.toFixed(2)) === 0
            ? (this.kfRegistrationDetail.categories[index].logistics !== 0
            ? this.kfRegistrationDetail.categories[index].logistics
            : (this.kfRegistrationDetail.kfRegistration.completionStatus ? this.kfRegistrationDetail.categories[index].logistics : null))
            : Number(this.kfRegistrationDetail.categories[index].logistics / this.equivalenceControl.value).toFixed(2)
        );
        control.get('treatment')?.setValue(
          Number(this.equivalenceControl.value.toFixed(2)) === 0
            ? (this.kfRegistrationDetail.categories[index].treatment !== 0
            ? this.kfRegistrationDetail.categories[index].treatment
            : (this.kfRegistrationDetail.kfRegistration.completionStatus ? this.kfRegistrationDetail.categories[index].treatment : null))
            : Number(this.kfRegistrationDetail.categories[index].treatment / this.equivalenceControl.value).toFixed(2)
        );
        control.get('clearingHouse')?.setValue(
          Number(this.equivalenceControl.value.toFixed(2)) === 0
            ? (this.kfRegistrationDetail.categories[index].clearingHouse !== 0
            ? this.kfRegistrationDetail.categories[index].clearingHouse
            : (this.kfRegistrationDetail.kfRegistration.completionStatus
              ? this.kfRegistrationDetail.categories[index].clearingHouse
              : null))
            : Number(this.kfRegistrationDetail.categories[index].clearingHouse / this.equivalenceControl.value).toFixed(2)
        );
        control.get('communication')?.setValue(
          Number(this.equivalenceControl.value.toFixed(2)) === 0
            ? (this.kfRegistrationDetail.categories[index].communication !== 0
            ? this.kfRegistrationDetail.categories[index].communication
            : (this.kfRegistrationDetail.kfRegistration.completionStatus
              ? this.kfRegistrationDetail.categories[index].communication
              : null))
            : Number(this.kfRegistrationDetail.categories[index].communication / this.equivalenceControl.value).toFixed(2)
        );
        control.get('rd')?.setValue(
          Number(this.equivalenceControl.value.toFixed(2)) === 0
            ? (this.kfRegistrationDetail.categories[index].rd !== 0
            ? this.kfRegistrationDetail.categories[index].rd
            : (this.kfRegistrationDetail.kfRegistration.completionStatus ? this.kfRegistrationDetail.categories[index].rd : null))
            : Number(this.kfRegistrationDetail.categories[index].rd / this.equivalenceControl.value).toFixed(2)
        );
        control.get('office')?.setValue(
          Number(this.equivalenceControl.value.toFixed(2)) === 0
            ? (this.kfRegistrationDetail.categories[index].office !== 0
            ? this.kfRegistrationDetail.categories[index].office
            : (this.kfRegistrationDetail.kfRegistration.completionStatus ? this.kfRegistrationDetail.categories[index].office : null))
            : Number(this.kfRegistrationDetail.categories[index].office / this.equivalenceControl.value).toFixed(2)
        );
        control.get('other')?.setValue(
          Number(this.equivalenceControl.value.toFixed(2)) === 0
            ? (this.kfRegistrationDetail.categories[index].other !== 0
            ? this.kfRegistrationDetail.categories[index].other
            : (this.kfRegistrationDetail.kfRegistration.completionStatus ? this.kfRegistrationDetail.categories[index].other : null))
            : Number(this.kfRegistrationDetail.categories[index].other / this.equivalenceControl.value).toFixed(2)
        );
        control.get('operationsRemark')?.setValue(this.kfRegistrationDetail.categories[index].operationsRemark);
        control.get('overheadRemark')?.setValue(this.kfRegistrationDetail.categories[index].overheadRemark);

      });
      this.kfRegistrationDetail.categories.forEach(() => {
        this.icon.push({icon: 'keyboard_arrow_right', expanded: false});
      });
    } else {
      this.currencyControl.setValue('Euro');
      this.setEntriesFormArray(this.categories.length, this.newKfRegistrationDetail);
      this.categories.forEach(() => {
        this.icon.push({icon: 'keyboard_arrow_right', expanded: false});
      });
    }

    if (this.kfRegistrationDetail?.kfRegistration?.completionStatus) {
      this.currencyControl.disable();
      this.equivalenceControl.disable();
      this.sourceControl.disable();
    }

    if (this.kfRegistrationDetail?.additional) {
      const additional: Additional[] = [];
      this.additionalControl.controls.forEach((entry, index) => {
        const category = this.getCategoryByIndex(index);
        const additionalItem = this.kfRegistrationDetail.additional?.filter(item => item.category === category)?.pop();
        const paymentRetail = Number(additionalItem?.paymentRetail && typeof(additionalItem?.paymentRetail) == "string" ? parseFloat(additionalItem?.paymentRetail) || 0 : additionalItem?.paymentRetail || 0);
        const paymentPoint = Number(additionalItem?.paymentPoint && typeof(additionalItem?.paymentPoint) == "string" ? parseFloat(additionalItem?.paymentPoint) || 0 : additionalItem?.paymentPoint || 0);
        const paymentOther = Number(additionalItem?.paymentOther && typeof(additionalItem?.paymentOther) == "string" ? parseFloat(additionalItem?.paymentOther) || 0 : additionalItem?.paymentOther || 0);
        additional.push({
          category,
          paymentRetail: Number(this.equivalenceControl.value) !== 0
            ? (paymentRetail / this.equivalenceControl.value).toFixed(2) : (paymentRetail === 0 ? undefined : paymentRetail),
          paymentPoint: Number(this.equivalenceControl.value) !== 0
            ? (paymentPoint / this.equivalenceControl.value).toFixed(2) : (paymentPoint === 0 ? undefined : paymentPoint),
          paymentOther: Number(this.equivalenceControl.value) !== 0
            ? (paymentOther / this.equivalenceControl.value).toFixed(2) : (paymentOther === 0 ? undefined : paymentOther),
          remarks: additionalItem?.remarks || ''
        });
      });
      this.additionalControl.patchValue(additional);
    }

    this.sum();
    if (this.simpleUser) {
      this.currencyForm.disable();
      this.entriesForm.disable();
      this.additionalForm.disable();
    }

  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  allowValidation(controlName: string, index: number): void {
    this.entriesControl.at(index).get(controlName)?.clearValidators();
    this.entriesControl.at(index).get(controlName)?.updateValueAndValidity();

    this.entriesControl.at(index).get(controlName + 'DifferentValueAllowed')?.setValue(true);
  }

  markAsCompleted(): void {
    if (this.kfRegistrationDetail) {
      this.kfRegistrationDetail.kfRegistration.currency = this.currencyControl.value;
      this.kfRegistrationDetail.kfRegistration.equivalence = this.equivalenceControl.value;
      this.kfRegistrationDetail.kfRegistration.source = this.sourceControl.value;
      this.kfRegistrationDetail.additional = this.setAdditionalValues();
      this.kfRegistrationDetail.categories = this.setEntriesValues();
      this.kfRegistrationService.saveKfRegistration(this.kfRegistrationDetail, this.router.url.split('/')[4]).subscribe(() => {
        this.markAsCompletedEmitter.emit();
      });
    } else {
      this.newKfRegistrationDetail.kfRegistration.currency = this.currencyControl.value;
      this.newKfRegistrationDetail.kfRegistration.equivalence = this.equivalenceControl.value;
      this.newKfRegistrationDetail.kfRegistration.source = this.sourceControl.value;
      this.newKfRegistrationDetail.categories = this.setEntriesValues();
      this.kfRegistrationService.saveKfRegistration(this.newKfRegistrationDetail, this.router.url.split('/')[4]).subscribe(() => {
        this.markAsCompletedEmitter.emit();
      });
    }
  }

  reset(): void {
    this.resetEmitter.emit();
  }

  changeIcon(i: number, icons: { icon: string; expanded: boolean; }[]): void {
    icons.forEach((icon, index: number) => {
      if (index === i) {
        icon.expanded = !icon.expanded;
        if (icon.expanded) {
          icon.icon = 'keyboard_arrow_down';
        } else {
          icon.icon = 'keyboard_arrow_right';
        }
      } else {
        icon.icon = 'keyboard_arrow_right';
        icon.expanded = false;
      }
    });
  }

  hideAllExpanded(): void {
    if (this.equivalenceControl.value === 0 || this.equivalenceControl.value === null) {
      this.icon.forEach(icon => {
        icon.icon = 'keyboard_arrow_right';
        icon.expanded = false;
      });
    }
  }

  entriesSubmit(): void {
    if (this.kfRegistrationDetail) {
      this.kfRegistrationDetail.kfRegistration.currency = this.currencyControl.value;
      this.kfRegistrationDetail.kfRegistration.equivalence = this.equivalenceControl.value;
      this.kfRegistrationDetail.kfRegistration.source = this.sourceControl.value;
      this.kfRegistrationDetail.additional = this.setAdditionalValues();
      this.kfRegistrationDetail.categories = this.setEntriesValues();
      this.kfRegistrationService.saveKfRegistration(this.kfRegistrationDetail, this.router.url.split('/')[4]).subscribe(() => {
        this.redirectUrlEmitter.emit(false);
      });
    } else {
      this.newKfRegistrationDetail.kfRegistration.currency = this.currencyControl.value;
      this.newKfRegistrationDetail.kfRegistration.equivalence = this.equivalenceControl.value;
      this.newKfRegistrationDetail.kfRegistration.source = this.sourceControl.value;
      this.newKfRegistrationDetail.additional = this.setAdditionalValues();
      this.newKfRegistrationDetail.categories = this.setEntriesValues();
      this.kfRegistrationService.saveKfRegistration(this.newKfRegistrationDetail, this.router.url.split('/')[4]).subscribe(() => {
        this.redirectUrlEmitter.emit(false);
      });
    }
  }

  private setEntriesFormArray(elements: number, kfRegistrationDetail: KfRegistrationDetail): void {
    this.entriesControl.clear();
    for (let i = 0; i < elements; i++) {
      // comparar b2bb2c del año pasado con el actual para comparar o no la categorias
      // comprobar que haya categorias el año pasado
      // comprobar que la categoría sea del constructor (que no se guardaron datos para poner restricciones)
      if (kfRegistrationDetail.lastYearDetailLevel === this.b2bb2c &&
        kfRegistrationDetail?.lastYearCategories !== undefined &&
        !kfRegistrationDetail?.kfRegistration?.completionStatus) {
        // recuperamos la categoria del año pasado correspondiente con la de este año
        const lastYearCategory = kfRegistrationDetail.lastYearCategories.find(cat => cat.keyFiguresCategory?.id === this.categories[i].id);
        if (lastYearCategory) {
          this.entriesControl.push(
            this.formBuilder.group({
                collection: [null, (!kfRegistrationDetail?.categories[i]?.collectionDifferentValueAllowed && lastYearCategory.collection) ?
                  [
                    Validators.max(lastYearCategory.collection + (kfRegistrationDetail?.deviation / 100 * lastYearCategory.collection)),
                    Validators.min(lastYearCategory.collection - (kfRegistrationDetail?.deviation / 100 * lastYearCategory.collection))
                  ] : []
                ],
                logistics: [null, (!kfRegistrationDetail?.categories[i]?.logisticsDifferentValueAllowed && lastYearCategory.logistics) ?
                  [
                    Validators.max(lastYearCategory.logistics + (kfRegistrationDetail?.deviation / 100 * lastYearCategory.logistics)),
                    Validators.min(lastYearCategory.logistics - (kfRegistrationDetail?.deviation / 100 * lastYearCategory.logistics))
                  ] : []
                ],
                treatment: [null, (!kfRegistrationDetail?.categories[i]?.treatmentDifferentValueAllowed && lastYearCategory.treatment) ?
                  [
                    Validators.max(lastYearCategory.treatment + (kfRegistrationDetail?.deviation / 100 * lastYearCategory.treatment)),
                    Validators.min(lastYearCategory.treatment - (kfRegistrationDetail?.deviation / 100 * lastYearCategory.treatment))
                  ] : []
                ],
                clearingHouse: [null, (!kfRegistrationDetail?.categories[i]?.clearingHouseDifferentValueAllowed && lastYearCategory.clearingHouse) ?
                  [
                    Validators.max(
                      lastYearCategory.clearingHouse + (kfRegistrationDetail?.deviation / 100 * lastYearCategory.clearingHouse)),
                    Validators.min(
                      lastYearCategory.clearingHouse - (kfRegistrationDetail?.deviation / 100 * lastYearCategory.clearingHouse))
                  ] : []
                ],
                communication: [null, (!kfRegistrationDetail?.categories[i]?.communicationDifferentValueAllowed && lastYearCategory.communication) ?
                  [
                    Validators.max(
                      lastYearCategory.communication + (kfRegistrationDetail?.deviation / 100 * lastYearCategory.communication)),
                    Validators.min(
                      lastYearCategory.communication - (kfRegistrationDetail?.deviation / 100 * lastYearCategory.communication))
                  ] : []
                ],
                rd: [null, (!kfRegistrationDetail?.categories[i]?.rdDifferentValueAllowed && lastYearCategory.rd) ?
                  [
                    Validators.max(lastYearCategory.rd + (kfRegistrationDetail?.deviation / 100 * lastYearCategory.rd)),
                    Validators.min(lastYearCategory.rd - (kfRegistrationDetail?.deviation / 100 * lastYearCategory.rd))
                  ] : []
                ],
                office: [null, (!kfRegistrationDetail?.categories[i]?.officeDifferentValueAllowed && lastYearCategory.office) ?
                  [
                    Validators.max(lastYearCategory.office + (kfRegistrationDetail?.deviation / 100 * lastYearCategory.office)),
                    Validators.min(lastYearCategory.office - (kfRegistrationDetail?.deviation / 100 * lastYearCategory.office))
                  ] : []
                ],
                other: [null],
                totalOperations: [0],
                totalOverhead: [0],
                operationsRemark: [''],
                overheadRemark: [''],
                collectionDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.collectionDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.collectionDifferentValueAllowed
                  : false
                ],
                logisticsDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.logisticsDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.logisticsDifferentValueAllowed
                  : false
                ],
                treatmentDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.treatmentDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.treatmentDifferentValueAllowed
                  : false
                ],
                clearingHouseDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.clearingHouseDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.clearingHouseDifferentValueAllowed
                  : false
                ],
                communicationDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.communicationDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.communicationDifferentValueAllowed
                  : false
                ],
                rdDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.rdDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.rdDifferentValueAllowed
                  : false
                ],
                officeDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.officeDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.officeDifferentValueAllowed
                  : false
                ],
                otherDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.otherDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.otherDifferentValueAllowed
                  : false
                ],
              }
            )
          );
        } else {
          // Si no existia esa categoria el año anterior construimos el campo del form sin validacion
          this.entriesControl.push(
            this.formBuilder.group({
                collection: [null, []],
                logistics: [null, []],
                treatment: [null, []],
                clearingHouse: [null, []],
                communication: [null, []],
                rd: [null, []],
                office: [null, []],
                other: [null, []],
                totalOperations: [0],
                totalOverhead: [0],
                operationsRemark: [''],
                overheadRemark: [''],
                collectionDifferentValueAllowed: [false],
                logisticsDifferentValueAllowed: [false],
                treatmentDifferentValueAllowed: [false],
                clearingHouseDifferentValueAllowed: [false],
                communicationDifferentValueAllowed: [false],
                rdDifferentValueAllowed: [false],
                officeDifferentValueAllowed: [false],
                otherDifferentValueAllowed: [false]
              }
            )
          );
        }
      } else {
        // form sin validacion
        this.entriesControl.push(
          this.formBuilder.group({
              collection: [null, []],
              logistics: [null, []],
              treatment: [null, []],
              clearingHouse: [null, []],
              communication: [null, []],
              rd: [null, []],
              office: [null, []],
              other: [null, []],
              totalOperations: [0],
              totalOverhead: [0],
              operationsRemark: [''],
              overheadRemark: [''],
              collectionDifferentValueAllowed: [false],
              logisticsDifferentValueAllowed: [false],
              treatmentDifferentValueAllowed: [false],
              clearingHouseDifferentValueAllowed: [false],
              communicationDifferentValueAllowed: [false],
              rdDifferentValueAllowed: [false],
              officeDifferentValueAllowed: [false],
              otherDifferentValueAllowed: [false]
            }
          )
        );
      }
    }
  }

  private setEntriesValues(): QuantitativeDetail[] {
    const quantitativeDetail: QuantitativeDetail[] = [];
    this.entriesControl.value.forEach(
      (entry: {
         clearingHouse: 0, collection: 0, communication: 0, rd: 0,
         logistics: 0, office: 0, other: 0, treatment: 0, operationsRemark: '', overheadRemark: '',
         collectionDifferentValueAllowed: false, logisticsDifferentValueAllowed: false, treatmentDifferentValueAllowed: false,
         clearingHouseDifferentValueAllowed: false, communicationDifferentValueAllowed: false, rdDifferentValueAllowed: false,
         officeDifferentValueAllowed: false, otherDifferentValueAllowed: false
       },
       index: number) => {
        const qd: QuantitativeDetail = {
          collection: entry.collection === null ? 0 :
            (this.currencyControl.value !== 'Euro' ?
              (parseFloat((entry.collection * this.equivalenceControl.value).toFixed(2))) : entry.collection),

          logistics: entry.logistics === null ? 0 :
            (this.currencyControl.value !== 'Euro' ?
              (parseFloat((entry.logistics * this.equivalenceControl.value).toFixed(2))) : entry.logistics),

          treatment: entry.treatment === null ? 0 :
            (this.currencyControl.value !== 'Euro' ?
              (parseFloat((entry.treatment * this.equivalenceControl.value).toFixed(2))) : entry.treatment),

          clearingHouse: entry.clearingHouse === null ? 0 :
            (this.currencyControl.value !== 'Euro' ?
              (parseFloat((entry.clearingHouse * this.equivalenceControl.value).toFixed(2))) : entry.clearingHouse),

          communication: entry.communication === null ? 0 :
            (this.currencyControl.value !== 'Euro' ?
              (parseFloat((entry.communication * this.equivalenceControl.value).toFixed(2))) : entry.communication),

          rd: entry.rd === null ? 0 :
            (this.currencyControl.value !== 'Euro' ?
              (parseFloat((entry.rd * this.equivalenceControl.value).toFixed(2))) : entry.rd),

          office: entry.office === null ? 0 :
            (this.currencyControl.value !== 'Euro' ?
              (parseFloat((entry.office * this.equivalenceControl.value).toFixed(2))) : entry.office),

          other: entry.other === null ? 0 :
            (this.currencyControl.value !== 'Euro' ?
              (parseFloat((entry.other * this.equivalenceControl.value).toFixed(2))) : entry.other),

          collectionDifferentValueAllowed: entry.collectionDifferentValueAllowed,
          logisticsDifferentValueAllowed: entry.logisticsDifferentValueAllowed,
          treatmentDifferentValueAllowed: entry.treatmentDifferentValueAllowed,
          clearingHouseDifferentValueAllowed: entry.clearingHouseDifferentValueAllowed,
          communicationDifferentValueAllowed: entry.communicationDifferentValueAllowed,
          rdDifferentValueAllowed: entry.rdDifferentValueAllowed,
          officeDifferentValueAllowed: entry.officeDifferentValueAllowed,
          otherDifferentValueAllowed: entry.otherDifferentValueAllowed,

          id: this.kfRegistrationDetail?.categories[index]?.id,
          keyFiguresCategory: this.categories[index],
          piecesValue: 0,
          tonsValue: 0,
          piecesDifferentValueAllowed: false,
          tonsDifferentValueAllowed: false,
          er: 0,
          erDifferentValueAllowed: false,
          ld: 0,
          ldDifferentValueAllowed: false,
          loss: 0,
          lossDifferentValueAllowed: false,
          omr: 0,
          omrDifferentValueAllowed: false,
          mr: 0,
          mrDifferentValueAllowed: false,
          ru: 0,
          ruDifferentValueAllowed: false,
          td: 0,
          tdDifferentValueAllowed: false,
          remark: '',
          operationsRemark: entry.operationsRemark,
          overheadRemark: entry.overheadRemark,
          kind: 3
        };
        quantitativeDetail.push(qd);
      });
    return quantitativeDetail;
  }

  private setAdditionalValues(): Additional[] {
    const additionalList: Additional[] = [];

    this.additionalControl.value.forEach((entry: { paymentRetail: 0, paymentPoint: 0, paymentOther: 0, remarks: '' }, index: number) => {
      const additional: Additional = {
        category: this.getCategoryByIndex(index),
      };
      additional.paymentRetail = (this.currencyControl.value !== 'Euro' ?
        ((entry.paymentRetail * this.equivalenceControl.value)) : entry.paymentRetail);
      additional.paymentPoint = (this.currencyControl.value !== 'Euro' ?
        ((entry.paymentPoint * this.equivalenceControl.value)) : entry.paymentPoint);
      additional.paymentOther = (this.currencyControl.value !== 'Euro' ?
        ((entry.paymentOther * this.equivalenceControl.value)) : entry.paymentOther);
      additional.remarks = entry.remarks;
      additionalList.push(additional);
    });
    return additionalList;
  }

  sum(): void {
    this.totalValues = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.entriesControl.value.forEach((value: any, index: number) => {
      value.totalOperations = 0;
      value.totalOverhead = 0;
      if (value.collection !== null && !Number.isNaN(value.collection)) {
        this.totalValues[0] += Number(value.collection);
        value.totalOperations += Number(value.collection);
      }
      if (value.logistics !== null && !Number.isNaN(value.logistics)) {
        this.totalValues[1] += Number(value.logistics);
        value.totalOperations += Number(value.logistics);
      }
      if (value.treatment !== null && !Number.isNaN(value.treatment)) {
        this.totalValues[2] += Number(value.treatment);
        value.totalOperations += Number(value.treatment);
      }
      if (!Number.isNaN(value.totalOperations)) {
        this.totalValues[3] += Number(value.totalOperations);
      }


      if (value.clearingHouse !== null && !Number.isNaN(value.clearingHouse)) {
        this.totalValues[4] += Number(value.clearingHouse);
        value.totalOverhead += Number(value.clearingHouse);
      }
      if (value.communication !== null && !Number.isNaN(value.communication)) {
        this.totalValues[5] += Number(value.communication);
        value.totalOverhead += Number(value.communication);
      }
      if (value.rd !== null && !Number.isNaN(value.rd)) {
        this.totalValues[6] += Number(value.rd);
        value.totalOverhead += Number(value.rd);
      }
      if (value.office !== null && !Number.isNaN(value.office)) {
        this.totalValues[7] += Number(value.office);
        value.totalOverhead += Number(value.office);
      }
      if (value.other !== null && !Number.isNaN(value.other)) {
        this.totalValues[8] += Number(value.other);
        value.totalOverhead += Number(value.other);
      }
      if (value.totalOverhead !== null && !Number.isNaN(value.totalOverhead)) {
        this.totalValues[9] += Number(value.totalOverhead);
      }


      if (value.totalOperations !== 0) {
        value.totalOperations = Math.round((value.totalOperations + Number.EPSILON) * 100) / 100;
        this.entriesControl.controls[index].get('totalOperations')?.setValue(value.totalOperations);
      }
      if (value.totalOverhead !== 0) {
        value.totalOverhead = Math.round((value.totalOverhead + Number.EPSILON) * 100) / 100;
        this.entriesControl.controls[index].get('totalOverhead')?.setValue(value.totalOverhead);
      }
      if (value.totalOperations === 0 && this.entriesControl.controls[index].get('totalOperations')?.value !== 0) {
        this.entriesControl.controls[index].get('totalOperations')?.setValue(0);
      }
      if (value.totalOverhead === 0 && this.entriesControl.controls[index].get('totalOverhead')?.value !== 0) {
        this.entriesControl.controls[index].get('totalOverhead')?.setValue(0);
      }
    });

    this.totalValues = this.totalValues.map(value => Math.round((value + Number.EPSILON) * 100) / 100);

  }

 private getCategoryByIndex(index: number): string {
    switch (index) {
      case 0:
        return 'A. Col. LHA';
      case 1:
        return 'B. Col. TEE';
      case 2:
        return 'C. Col. Small IT';
      case 3:
        return 'D. Col. Small';
      case 4:
        return 'E. Col. Screens';
      case 5:
        return 'F. Col. Lamps';
      case 6:
        return 'G. Col. PV';
      case 7:
        return 'X. Col Other';
    }
    return '';
  }

}
